import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Typography, Button } from '@mui/material';
import { ApiContext } from '../../../App';

import { useTranslation } from "react-i18next";



export default function CogenConfig (props) {

    const currencySymbol = "₺";

    const {facility} = props;

    const { t } = useTranslation();

    const [cogenData, setCogenData] = React.useState({});

    const [errorMessages, setErrorMessages] = React.useState({});

    const {coGenConfigApi, facilityApi} = React.useContext(ApiContext)

    React.useEffect(() => {

        coGenConfigApi.retrieve(
            facility,
            data => {  
                setCogenData(data);
            },
            ()=>{
              alert(t("Couldn't connect to server."));
            }
          )
    },[facility])

    const handleFormChange = (id, val) => {
        setCogenData((c)=>({...c, [id]:val}))
    }

    const handleSave = ()  => {

        setErrorMessages({});

        const onSuccess = (id) => {
            alert("Updated correctly.")
        }

        const onError = (response) => {
            setErrorMessages(response);
        }

        coGenConfigApi.update(
            cogenData.url,
            cogenData,
            onSuccess, 
            onError
        )

    }

    return (
        <>

        <Box width={250}>
            <Stack spacing={2}>
                <Typography color="primary" variant="h6">
                    {t("Electricity")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"co_generation_subsidy_MWh"}
                        label={t("Co-generation subsidy", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.co_generation_subsidy_MWh ?? 0}
                        onChange={(props)=>handleFormChange("co_generation_subsidy_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("co_generation_subsidy_MWh")}
                        helperText={errorMessages["co_generation_subsidy_MWh"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"power_distribution_cost_MWh"}
                        label={t("Distribution cost", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.power_distribution_cost_MWh ?? 0}
                        onChange={(props)=>handleFormChange("power_distribution_cost_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("power_distribution_cost_MWh")}
                        helperText={errorMessages["power_distribution_cost_MWh"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"power_transmission_cost_MWh"}
                        label={t("Transmission cost" , {currency: currencySymbol})}
                        type="number"
                        value={cogenData.power_transmission_cost_MWh ?? 0}
                        onChange={(props)=>handleFormChange("power_transmission_cost_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("power_transmission_cost_MWh")}
                        helperText={errorMessages["power_transmission_cost_MWh"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"electricity_discount_MWh"}
                        label={t("Electricity discount", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.electricity_discount_MWh ?? 0}
                        onChange={(props)=>handleFormChange("electricity_discount_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("electricity_discount_MWh")}
                        helperText={errorMessages["electricity_discount_MWh"] ?? ""}                       
                    />

                <TextField
                    variant="standard"
                    id={"electricity_discount_percentage"}
                    label={t("Electricity discount (%)")}
                    type="number"
                    value={cogenData.electricity_discount_percentage ?? 0}
                    onChange={(props)=>handleFormChange("electricity_discount_percentage", props.target.value)}
                    error={errorMessages.hasOwnProperty("electricity_discount_percentage")}
                    helperText={errorMessages["electricity_discount_percentage"] ?? ""}
                />
                
                <Typography color="primary" variant="h6">
                    {t("Gas")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"gas_usage_fee"}
                        label={t("Gas usage fee", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.gas_usage_fee ?? 0}
                        onChange={(props)=>handleFormChange("gas_usage_fee", props.target.value)}
                        error={errorMessages.hasOwnProperty("gas_usage_fee")}
                        helperText={errorMessages["gas_usage_fee"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"gas_distribution_company_profit"}
                        label={t("Distribution company profit")}
                        type="number"
                        value={cogenData.gas_distribution_company_profit ?? 0}
                        onChange={(props)=>handleFormChange("gas_distribution_company_profit", props.target.value)}
                        error={errorMessages.hasOwnProperty("gas_distribution_company_profit")}
                        helperText={errorMessages["gas_distribution_company_profit"] ?? ""}                       
                    />
                <Typography color="primary" variant="h6">
                    {t("Steam")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"cost_per_ton_steam"}
                        label={t("Cost of steam production", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.cost_per_ton_steam ?? 0}
                        onChange={(props)=>handleFormChange("cost_per_ton_steam", props.target.value)}
                        error={errorMessages.hasOwnProperty("cost_per_ton_steam")}
                        helperText={errorMessages["cost_per_ton_steam"] ?? ""}                       
                    />
                <TextField
                    variant="standard"
                    id={"steam_demand_T_per_MWh_energy_demand"}
                    label={t("Steam demand (T/MWh)")}
                    type="number"
                    value={cogenData.steam_demand_T_per_MWh_energy_demand ?? 0}
                    onChange={(props)=>handleFormChange("steam_demand_T_per_MWh_energy_demand", props.target.value)}
                    error={errorMessages.hasOwnProperty("steam_demand_T_per_MWh_energy_demand")}
                    helperText={errorMessages["steam_demand_T_per_MWh_energy_demand"] ?? ""}                       
                />
                <Typography color="primary" variant="h6">
                    {t("Manual baseline")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"co_gen_critical_price"}
                        label={t("Critical price", {currency: currencySymbol})}
                        type="number"
                        value={cogenData.co_gen_critical_price ?? 0}
                        onChange={(props)=>handleFormChange("co_gen_critical_price", props.target.value)}
                        error={errorMessages.hasOwnProperty("co_gen_critical_price")}
                        helperText={errorMessages["co_gen_critical_price"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"co_gen_manual_min_hours"}
                        label={t("Min. hours")}
                        type="number"
                        value={cogenData.co_gen_manual_min_hours ?? 0}
                        onChange={(props)=>handleFormChange("co_gen_manual_min_hours", props.target.value)}
                        error={errorMessages.hasOwnProperty("co_gen_manual_min_hours")}
                        helperText={errorMessages["co_gen_manual_min_hours"] ?? ""}                       
                    />
                <Typography color="primary" variant="h6">
                    {t("Carbon intensity")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"CO2_grid_kg_per_MWh"}
                        label={t("kg CO2/MWh (grid)")}
                        type="number"
                        value={cogenData.CO2_grid_kg_per_MWh ?? 0}
                        onChange={(props)=>handleFormChange("CO2_grid_kg_per_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("CO2_grid_kg_per_MWh")}
                        helperText={errorMessages["CO2_grid_kg_per_MWh"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"CO2_gas_kg_per_MWh"}
                        label={t("kg CO2/MWh (gas)")}
                        type="number"
                        value={cogenData.CO2_gas_kg_per_MWh ?? 0}
                        onChange={(props)=>handleFormChange("CO2_gas_kg_per_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("CO2_gas_kg_per_MWh")}
                        helperText={errorMessages["CO2_gas_kg_per_MWh"] ?? ""}                       
                    />
                <TextField
                        variant="standard"
                        id={"CO2_coal_kg_per_MWh"}
                        label={t("kg CO2/MWh (coal)")}
                        type="number"
                        value={cogenData.CO2_coal_kg_per_MWh ?? 0}
                        onChange={(props)=>handleFormChange("CO2_coal_kg_per_MWh", props.target.value)}
                        error={errorMessages.hasOwnProperty("CO2_coal_kg_per_MWh")}
                        helperText={errorMessages["CO2_coal_kg_per_MWh"] ?? ""}                       
                    />
                <Typography color="primary" variant="h6">
                    {t("Reports")}
                </Typography>
                <TextField
                        variant="standard"
                        id={"co_gen_report_email_addresses"}
                        label={t("Email addresses")}
                        value={cogenData.co_gen_report_email_addresses ?? ""}
                        onChange={(props)=>handleFormChange("co_gen_report_email_addresses", props.target.value)}
                        error={errorMessages.hasOwnProperty("co_gen_report_email_addresses")}
                        helperText={errorMessages["co_gen_report_email_addresses"] ?? ""}                       
                    />
                <Button variant="contained" onClick={handleSave}>
                    {t("Update")}
                </Button>
            </Stack>
            
        </Box>
        
        </>
    )


}